import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import config from '../../../application/config/config';
import Fetch from "../../../core/util/core/Fetch";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";

import Data from "./Tabs/Data.js"
import Phones from "./Tabs/Phones.js"
import Emails from "./Tabs/Emails.js"
import Addresses from "./Tabs/Addresses.js";

import TreeView from "../../../core/components/core/ApplicationsProfiles/PermissionTreeview";
import { CheckIfIsViewScreen } from "../../../core/util/core/CheckIfIsViewScreen";

function Edit() {
  const [activeTab, setActiveTab] = useState('data');
  const [isLoading, setIsLoading] = useState(true)
  const [formValues, setFormValues] = useState(null)
  const [permission, setPermission] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const isView = CheckIfIsViewScreen();
  const navigate = useNavigate();
  const formSession = useSelector(state => state.session);

  const { id } = useParams();

  const paths = {
    endpointGetById: config.endpoints.backend + 'gci/project-managers/getById',
    endpointPermissionSave: config.endpoints.backend + 'core/users/updatepermissions',
    endpointGetAppProfileById: config.endpoints.backend + 'core/applicationsprofiles/getById',
  }

  useEffect(() => {
    const load = async () => {
      const values = await Fetch.post(paths.endpointGetById, { id })
      setFormValues(values)
      setIsLoading(false)
    }
    load()
  }, [])

  function addPropertiesRecursive(array) {
    return array.map((item) => {
      const newItem = { ...item };
      newItem.canView = true;
      newItem.canAdd = true;
      newItem.canEdit = true;
      newItem.canDelete = true;

      if (newItem.children && newItem.children.length > 0) {
        newItem.children = addPropertiesRecursive(newItem.children);
      }

      return newItem;
    });
  }

  const handleSubmit = async (fields, values, loadData) => {
    const finalPermission = formSession["current_user_permission"];
    const finalValues = { ...values, permissions: finalPermission };
    await Fetch.put(paths.endpointSave, finalValues);
    navigate(paths.urlGoBack);
  };

  const handleChangeTreeView = async (permissions) => {
    const finalValues = { id: formValues.core_user_id, permissions: permissions };
    setPermission(permissions);
    await Fetch.put(paths.endpointPermissionSave, finalValues);
  };

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'data' })}
            onClick={() => {
              setActiveTab('data');
            }}
          >
            Dados
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'phones' })}
            onClick={() => {
              setActiveTab('phones');
            }}
          >
            Contatos
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'emails' })}
            onClick={() => {
              setActiveTab('emails');
            }}
          >
            Emails
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === 'addresses' })}
            onClick={() => {
              setActiveTab('addresses');
            }}
          >
            Endereços
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "list" })}
            onClick={() => {
              setActiveTab("list");
            }}
          >
            Permissionamento
          </NavLink>
        </NavItem>
      </Nav>
      {
        isLoading ? <p> Carregando.. </p> : (
          <TabContent activeTab={activeTab} className="bg-white">
            <TabPane tabId={'data'}>
              <Col sm="12">
                <Data handleSubmit={handleSubmit} />
              </Col>
            </TabPane>
            <TabPane tabId={'phones'}>
              <Col sm="12">
                <Phones formValues={formValues} />
              </Col>
            </TabPane>
            <TabPane tabId={'emails'}>
              <Col sm="12">
                <Emails formValues={formValues} />
              </Col>
            </TabPane>
            <TabPane tabId={'addresses'}>
              <Col sm="12">
                <Addresses formValues={formValues} />
              </Col>
            </TabPane>
            <TabPane tabId="list">
              <Col sm="12">
                <TreeView
                  disabled={isView}
                  endpointGetById={paths.endpointGetById}
                  fromUser={true}
                  addPropertiesRecursive={addPropertiesRecursive}
                  permission={permission}
                  setPermission={setPermission}
                  allPermissions={allPermissions}
                  setAllPermissions={setAllPermissions}
                  handleChange={handleChangeTreeView}
                  activeTab={activeTab}
                />
              </Col>
            </TabPane>
          </TabContent>
        )
      }
    </div>
  );
}
export default Edit;